<template class="link">
    <tr @click="show_modal(snapshot)" class="snapshot">
      <td :data-label="translate('snapshots.order_name')" class="">
        {{ snapshot.order_name }}
      </td>
      <td :data-label="translate('snapshots.client_name')" class="">
        {{ snapshot.client_name }}
      </td>
      <td :data-label="translate('snapshots.device')" @click.stop="">
        <router-link :to="{path: '/device/' + snapshot.fid}">
          {{ snapshot.fid }}
        </router-link>
        <p>
          {{ snapshot.device_name }}
        </p>
      </td>
      <td :data-label="translate('snapshots.user')" class="" @click.stop= "">
        <router-link :to="{path: '/user/' + snapshot.user_name}">
          {{ snapshot.user_name }}
        </router-link>
      </td>
      <td :data-label="translate('snapshots.status')" class="">
        <span class="badge" :class="get_status(snapshot.status).color">
          {{ get_status(snapshot.status).title }}
        </span>
      </td>
      <td :data-label="translate('snapshots.model_name')" class="">
        {{ snapshot.device_model_name }}
      </td>
      <td :data-label="translate('snapshots.modems_count')" class="">
        {{ snapshot.modems_count }}
      </td>
      <td :data-label="translate('snapshots.created')" class="">
        {{ get_date(snapshot.created_at, ts_date_options) }}
      </td>
    </tr>
</template>
<script>

import SnapshotsModal from "../Modal/Index.vue";

export default {
  name: 'SnapshotsListItem',
  props: ["snapshot"],
  data () {
    return {
      ts_date_options:{
        hour12: false,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }
    }
  },
  methods: {
    get_status(status){
      return this.$store.getters.getSnapshotsInfo.statuses.find((entry) => {
        if (entry.title === status) return entry
      })
    },

    show_modal(data){
      let t = this.$createElement(SnapshotsModal, {
        props: {
          data
        },
        on: {
          close: () => {this.$modal.hide('snapshots_modal') }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', width: 800, adaptive: true, clickToClose: true, scrollable: true, name: 'snapshots_modal'})
    },
  },
}
</script>

<style lang="scss" scoped>
 .snapshot{
   cursor: pointer;
   color: #252422;
   height: auto;
   &:hover{
     tr{
       background-color: #eee;
     }
   }
   td{
     overflow: hidden;
     a,p{
       margin: 0;
     }
   }
   .level{
     display: inline-block;
     width: 20px;
     height: 100%;
   }
   .w180{
     max-width: 180px;
     width: 180px;
   }
   .w100{
     max-width: 100px;
     width: 100px;
   }
   .has_child{
     background-color: #eee;
     font-weight: bold;
   }
   .name{
     text-align: left;
   }
   .inn{
     text-align: left;
   }
 }
</style>
